"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GemsContainer = void 0;
var GameVars_1 = require("../../../GameVars");
var GemsContainer = /** @class */ (function (_super) {
    __extends(GemsContainer, _super);
    function GemsContainer(scene) {
        var _this = _super.call(this, scene) || this;
        _this.y = 115 * GameVars_1.GameVars.scaleY;
        _this.scaleY = GameVars_1.GameVars.scaleY;
        var barBackgroundWidth = 445;
        var barBackgroundHeight = 25;
        var barBackground = new Phaser.GameObjects.Graphics(_this.scene);
        barBackground.fillStyle(0xF7E3DE);
        barBackground.fillRect(-barBackgroundWidth / 2, -barBackgroundHeight / 2, barBackgroundWidth, barBackgroundHeight);
        _this.add(barBackground);
        var containerFrame = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_0", "lvl_bar");
        _this.add(containerFrame);
        _this.bar = new Phaser.GameObjects.Image(_this.scene, -200, 0, "texture_atlas_0", "lvl_bar_fill");
        _this.bar.setOrigin(0, .5);
        _this.bar.scaleX = GemsContainer.BAR_FULL_SCALE * GameVars_1.GameVars.modeGameData.starsPartialCounter / GameVars_1.GameVars.starsThresholdValues[GameVars_1.GameVars.modeGameData.stars];
        _this.add(_this.bar);
        _this.barTip = new Phaser.GameObjects.Image(_this.scene, _this.bar.x + _this.bar.width * _this.bar.scaleX, 0, "texture_atlas_0", "lvl_bar_fill_end");
        _this.barTip.setOrigin(0, .5);
        _this.add(_this.barTip);
        _this.gemContainer = new Phaser.GameObjects.Container(_this.scene);
        _this.gemContainer.x = -206;
        _this.add(_this.gemContainer);
        var gemIcon = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "lvl_bar_gem");
        _this.gemContainer.add(gemIcon);
        _this.starsLabel = new Phaser.GameObjects.Text(_this.scene, 0, -10, (GameVars_1.GameVars.modeGameData.stars + 1).toString(), { fontFamily: "Baloo", fontSize: "38px", color: "#FFFD2D" });
        _this.starsLabel.setOrigin(.5);
        _this.starsLabel.setStroke("#126800", 5);
        _this.gemContainer.add(_this.starsLabel);
        _this.starCounterLabel = new Phaser.GameObjects.Text(_this.scene, 0, -2, GameVars_1.GameVars.modeGameData.starsPartialCounter.toString() + "/" + GameVars_1.GameVars.starsThresholdValues[GameVars_1.GameVars.modeGameData.stars], { fontFamily: "Baloo", fontSize: "30px", color: "#E963BC" });
        _this.starCounterLabel.setOrigin(.5);
        _this.starCounterLabel.setStroke("#6331B3", 5);
        _this.add(_this.starCounterLabel);
        return _this;
    }
    GemsContainer.prototype.updateGems = function () {
        this.starCounterLabel.text = GameVars_1.GameVars.modeGameData.starsPartialCounter.toString() + "/" + GameVars_1.GameVars.starsThresholdValues[GameVars_1.GameVars.modeGameData.stars];
        this.bar.scaleX = GemsContainer.BAR_FULL_SCALE * GameVars_1.GameVars.modeGameData.starsPartialCounter / GameVars_1.GameVars.starsThresholdValues[GameVars_1.GameVars.modeGameData.stars];
        this.barTip.x = this.bar.x + this.bar.width * this.bar.scaleX;
        this.scene.tweens.add({
            targets: this.gemContainer,
            scaleX: 1.15,
            scaleY: 1.15,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 100,
            delay: 350,
            yoyo: true
        });
        this.starsLabel.text = (GameVars_1.GameVars.modeGameData.stars + 1).toString();
    };
    GemsContainer.BAR_FULL_SCALE = 13.75;
    return GemsContainer;
}(Phaser.GameObjects.Container));
exports.GemsContainer = GemsContainer;
